<template>
  <acWrap>
    <div class="rg-con">
      <p class="rg-head"><span>{{name}}</span></p>
      <div class="rg-content">
        <acForget @change="change"></acForget>
      </div>
    </div>
  </acWrap>
</template>

<script>
  import acWrap from './components/Wrap.vue'
  import acForget from '../../components/account/Forget.vue'
  export default {
    data() {
      return {
        name: '验证账号'
      }
    },
    methods: {
      change(num) {
        switch(num) {
          case 1:
          this.name = '重置密码'
          break;
          default:
          this.name = '验证账号'
          break;
        }
      }
    },
    components: {
      acWrap,
      acForget
    }
  }

</script>

<style lang="stylus" scoped>
  .rg-con {
    width: 700px;
    height: 100%;
    margin: 0 auto;
    .rg-head {
      text-align: left;
      text-indent: 240px;
      line-height: 150px;
      font-size: 16px;
      color: #333333;
      span {
        /* border: 1px solid green;  */
        position: relative;
        &:after {
          width: 40px;
          display: inline-block;
          background: #2ea9df;
          height: 2px;
          position: absolute;
          content: '';
          bottom: -10px;
          left: 10px;
        }
      }
    }
    .rg-content {
      width: 100%;
      height: calc( 100% - 150px);
      position: relative;
    }
  }

</style>



// WEBPACK FOOTER //
// Forget.vue?c904ff30